export const ALERTTRIGGER_STORE_KEY = 'alertTrigger';
export const ALERTTRIGGER_SERVICE_KEY = 'alertTrigger';
export const ALERTTRIGGER_API_URL = '/api/v1/alert_trigger/';
